import * as React from "react";

/**
 * Optional state-management hook for callers that want simple uncontrolled
 * open/close handling without wiring up `useState` themselves.
 */
export const useResponsivePopover = (defaultOpen = false) => {
  const [open, setOpen] = React.useState(defaultOpen);

  const openPopover = React.useCallback(() => setOpen(true), []);
  const closePopover = React.useCallback(() => setOpen(false), []);
  const togglePopover = React.useCallback(() => setOpen((prev) => !prev), []);

  return {
    open,
    openPopover,
    closePopover,
    togglePopover,
    setOpen,
  };
};
